<template>
  <v-menu
    v-if="hasAnyItemsInMenu"
    v-model="showingMenu"
    v-bind:close-on-content-click="false"
    location="bottom"
    eager
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>

    <v-list data-cy="pod-file-list">
      <v-list-item
        v-if="$canControlNodeAndPod()"
        @click="openBadgeStatusMenu"
        ref="badgeStatusTarget"
        prepend-icon="mdi-state-machine"
      >
        <v-list-item-title>{{ $t('routes.pod.setBadgeStatus') }}</v-list-item-title>
        <v-list-item-subtitle>{{ getBadgeStatusText }}</v-list-item-subtitle>
      </v-list-item>

      <v-divider aria-hidden="true" />

      <v-list-item
        v-if="$canControlNodeAndPod()"
        @click="showRenamePodDialog"
        data-cy="list-podItem-actions-renamePod"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-form-textbox</v-icon>
        </template>

        <v-list-item-title>{{ $t('routes.node.renamePod') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$canControlNodeAndPod()"
        @click="showCopyPodDialog"
        data-cy="pod-file-list-copy"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-checkbox-multiple-marked-outline</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.copy') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$canControlNodeAndPod()"
        @click="showMovePodDialog"
        data-cy="pod-file-list-move"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-checkbox-multiple-marked</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.move') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$canDeleteNodeAndPod()"
        @click="showDeletePodDialog"
        data-cy="pod-file-list-delete"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-trash-can</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.delete') }}
        </v-list-item-title>
      </v-list-item>

      <v-divider v-if="$isTeamUser() && $canControlNodeAndPod()" aria-hidden="true" />

      <v-list-item
        v-if="$isTeamUser() && $canControlNodeAndPod()"
        @click="toggleTeamonly()"
        data-cy="pod-file-list-teamOnly"
      >
        <template v-slot:prepend>
          <v-icon size="small">
            {{ pod.teamonly ? 'mdi-file-lock-open' : 'mdi-file-lock-outline' }}
          </v-icon>
        </template>

        <v-list-item-title>
          {{ pod.teamonly ? $t('routes.node.removeTeamOnlyAccess') : $t('routes.node.setTeamOnlyAccess') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$canListPodService()"
        @click="showEmbedMediaDialog"
        data-cy="pod-file-list-embedMedia"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-xml</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.menuTools.embedMedia') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$canListPodService()"
        @click="showManageVersionsDialog"
        data-cy="pod-file-list-manageVersions"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-counter</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.menuTools.manageVersions') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <PodBadgeStatusMenu
    v-if="$canControlNodeAndPod()"
    v-model="showingBadgeStatusMenu"
    :item="pod"
    :target="$refs.badgeStatusTarget"
  />
  <RenamePodDialog v-model="showingRenamePodDialog" :pod="pod"/>
  <CopySelectedDialog v-model="showingCopyPodDialog" :pods="[pod]" :nodes="[]"/>
  <MoveSelectedDialog v-model="showingMovePodDialog" :pods="[pod]" :nodes="[]"/>
  <DeletePodDialog v-model="showingDeletePodDialog" :pod="pod"/>
  <EmbedMediaDialog v-model="showingEmbedMediaDialog" :pod="pod"/>
  <ManageVersionsDialog v-model="showingManageVersionsDialog" />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useCommonStore } from '@/stores/CommonStore.js';
import PodBadgeStatusMenu from "../../../nodes2/components/contextMenus/PodBadgeStatusMenu.vue"
import DeletePodDialog from "../../../nodes2/components/dialogs/DeletePodDialog.vue"
import CopySelectedDialog from "../../../nodes2/components/dialogs/CopySelectedDialog.vue"
import MoveSelectedDialog from "../../../nodes2/components/dialogs/MoveSelectedDialog.vue"
import ManageVersionsDialog from "../dialogs/manageVersions/ManageVersionsDialog.vue"
import EmbedMediaDialog from "../dialogs/embedMedia/EmbedMediaDialog.vue"


import RenamePodDialog from '@/routes/nodes2/components/dialogs/RenamePodDialog.vue';

export default {
  name: "FileContextMenu",
  components: {
    RenamePodDialog,
    DeletePodDialog,
    MoveSelectedDialog,
    CopySelectedDialog,
    ManageVersionsDialog,
    EmbedMediaDialog,
    PodBadgeStatusMenu,
  },
  data() {
    return {
      showingMenu: false,
      showingBadgeStatusMenu: false,
      showingRenamePodDialog: false,
      showingCopyPodDialog: false,
      showingMovePodDialog: false,
      showingDeletePodDialog: false,
      showingEmbedMediaDialog: false,
      showingManageVersionsDialog: false,
    }
  },
  methods: {
    stub: function() {
      this.showingMenu = false;
    },
    openBadgeStatusMenu() {
      this.showingBadgeStatusMenu = true;
    },
    showRenamePodDialog: function() {
      this.showingRenamePodDialog = true;
      this.showingMenu = false;
    },
    showCopyPodDialog: function() {
      this.showingCopyPodDialog = true;
      this.showingMenu = false;
    },
    showMovePodDialog: function() {
      this.showingMovePodDialog = true;
      this.showingMenu = false;
    },
    showDeletePodDialog: function() {
      this.showingDeletePodDialog = true;
      this.showingMenu = false;
    },
    showEmbedMediaDialog: function() {
      this.showingEmbedMediaDialog = true;
      this.showingMenu = false;
    },
    showManageVersionsDialog: function() {
      this.showingManageVersionsDialog = true;
      this.showingMenu = false;
    },
    toggleTeamonly: function () {
      let podData = {
        id: this.pod.id,
        teamonly: !this.pod.teamonly ? 1 : 0,
      };

      const podStore = usePodStore();
      podStore.updateTeamOnly(podData)
        .then(() => {
          this.$showMessage(this.$t('routes.pod.teamonlyAccessUpdated'), { type: 'success' });
        })
        .catch(function (error) {
          if (error && error.message) {
            self.$showMessage(error.message, { type: 'error' });
          } else {
            console.log(error);
            self.$showMessage(self.$t('backend.system-error'), { type: 'error' });
          }
        });
    },
  },
  computed: {
    hasAnyItemsInMenu: function () {
      return this.$canListPodService() || this.$canControlNodeAndPod();
    },
    pod: function () {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    badgeStatuses: function() {
      const commonStore = useCommonStore();
      return commonStore.podBadgeStatuses;
    },
    getBadgeStatusText: function() {
      if (!this.pod) {
        return '';
      }

      switch (this.pod.badgestatus) {
        case this.badgeStatuses.NOTSELECTED: return this.$t('routes.pod.badgeStatusNotSelected');
        case this.badgeStatuses.NEW: return this.$t('routes.pod.badgeStatusNew');
        case this.badgeStatuses.DRAFT: return this.$t('routes.pod.badgeStatusDraft');
        case this.badgeStatuses.PRODUCTION: return this.$t('routes.pod.badgeStatusProduction');
        case this.badgeStatuses.REVIEW: return this.$t('routes.pod.badgeStatusReview');
        case this.badgeStatuses.CORRECTION: return this.$t('routes.pod.badgeStatusCorrection');
        case this.badgeStatuses.FINAL: return this.$t('routes.pod.badgeStatusFinal');
        default: return '';
      }
    },
  },
}
</script>

<style>
</style>
